import { Skeleton, SkeletonProps } from '@dixa/lib-shared-habla';
import { sizes } from '@dixa/lib-shared-tokens';

export const AvatarPlaceholder = <
  TElementType extends keyof JSX.IntrinsicElements,
>({
  ...rest
}: SkeletonProps<TElementType>): JSX.Element => {
  return (
    <Skeleton
      width="24px"
      height="24px"
      borderRadius={sizes['border-radius']['100']}
      {...rest}
    />
  );
};
